<button
  class="icon-btn"
  [class]="extraClass"
  type="button"
  (click)="onClick($event)"
>
  <!-- SVG được truyền vào từ component cha -->
  <span class="icon-btn__icon">
    <ng-content></ng-content>
  </span>
  <span *ngIf="label" class="icon-btn__label">{{ label }}</span>
</button>
